export abstract class PrinterService {
  abstract printText(text: string): Promise<void>;
  abstract printFile(file: string): Promise<void>;
  abstract printData(blob: Blob): Promise<void>;
}
